const globalMessageEN = {
	next: 'Next',
	edit: 'Edit',
	true: 'True',
	false: 'False',
	complete: 'Complete',
	finish: 'Finish',
	with: 'with',
	done: 'Done',
	select: 'Select',
	loading: 'Loading',
	send: 'Send',
	save: 'Save',
	tryAgain: 'Try Again',
	cancel: 'Cancel',
	submit: 'Submit',
	ok: 'OK',
	okay: 'Okay',
	discard: 'Discard',
	close: 'Close',
	or: 'or',
	download: 'Download',
	logОut: 'Log Out',
	general: 'General',
	none: 'None',
	continue: 'Continue',
	proceed: 'Proceed',
	changeSimulation: 'Change Simulation',
	chooseSimulation: 'Please choose a Simulation',
	currentSimulation: '(current simulation)',
	reports: 'Reports',
	confirm: 'Confirm',
	remove: 'Remove',
	endDate: 'End Date',
	try: 'Try',
	playAgain: 'Play Again',
	replayOption: 'Replay Option',
	completeLifeStageOption: 'Complete Life Stage',
	finalizeBudget: 'Finalize Budget',
	finalizeShopping: 'Complete Shopping',
	backToReportLink: 'Back to Report | Back to Reports',
	new: 'New',
	passcodeIsRequired: 'Passcode is required',
	passcodeHelperText: 'Please enter your 3-digit code to continue...',
	passcodeModalText:
		'You will be provided with a 3-digit passcode. Please type in your passcode in order to continue.',
	incorrectPasscode: 'The code you have entered is not correct.',
	passcodeInputLabel: 'Your Code',
	passcodeInputPlaceholder: 'Type your code here',
	amountSpent: 'Amount Spent',
	amountLeftToSpend: 'Amount Left To Spend',
	questionInputPlaceholder: 'Type your answer...',
	requiredInputError: 'Please enter {field}',
	sucessfull: 'sucessfull',
	errorSync: 'someting went wrong try again',
	errorImportFile: 'Only .json file extensions allowed.'
};

const loginMessagesEN = {
	login: 'Login',
	loginMsg: 'Login to JA Finance Park',
	sponsoredBy: 'Sponsored by',
	anotherStudentConcurrent1:
		'Uh oh! Looks like someone’s already logged in with your username:',
	anotherStudentConcurrent2:
		'Double-check your credentials before moving forward.',
	anotherStudentOther1:
		'Uh oh! Looks like someone just logged in with your username:',
	anotherStudentOther2: 'Please see a JA staff member before moving forward.',
	codeIncorrect: 'The pin/code is not correct',
	logInAnyway: 'log in anyway'
};

const logoutEN = {
	logout: 'Logout',
	logoutQuestion: 'Are you sure you want to log out from the system?',
	closeSimulation: 'Close Simulation'
};

const careerClustersMessagesEN = {
	careerClustersTitle: 'Choose a Career Cluster',
	careerClustersDescription:
		'The old saying "find a job you love and never work a day in your life" is relevant for some people and not others. It all boils down to what you interests, skills and values are. Do you value work-life balance? Or do you put more emphasis on earning a high salary?',
	careerClustersTitleInfo:
		"Below you'll be able to explore different career clusters, careers, and jobs. Discover the career that suits you by selecting Explore below a career cluster. As you scroll, select Show More to read through different careers. You'll see a different job in your chosen career path during each life stage. When you're ready, select a career and then continue to the next screen.",
	explore: 'Explore',
	responsibilities: 'Responsibilities',
	careerPath: 'Career Path',
	showMore: 'Show More',
	showLess: 'Show Less'
};

const goalsMessagesEN = {
	goalsScreenTitleQuestion: 'What are some of your savings goals?',
	goalsScreenTitleInfo: `Select up to three goals (minimum of one). In each life stage, you will decide how much to save every month towards each goal. Some goals may be achieved quicker than others!
	`,
	selectedGoalsCounter: '{count} selected',
	goalsCountAlert: 'Select a maximum of three goals.'
};

const interestsMessagesEN = {
	interestsScreenTitleQuestion: 'What are you most interested in?',
	interestsScreenTitleInfo:
		'Choose your top three interests. Heads up! Random life events tied to your interests will pop-up throughout the simulation, which could positively or negatively impact your checking or savings accounts.',
	interestsSelectedCounter: '{counter}/{maxCount} selected',
	interestsCountAlert: 'Select only three interests.'
};

const avatarsMessagesEN = {
	avatarsInfo: 'Select an avatar from the right-hand panel.',
	avatarsTitle: 'avatar',
	avatarsSubtitle: 'Create Your Avatar',
	avatarsPresetLabel: 'Choose an avatar',
	avatarsFaceShapeLabel: 'Face Shape',
	avatarsHairColorLabel: 'Hair Color',
	avatarsSkinColorLabel: 'Skin Color',
	avatarsEyesColorLabel: 'Eye Color',
	avatarsPredefinedSegment: 'Select Predefined',
	avatarsCustomSegment: 'Create Your Own'
};

const profileMessagesEN = {
	budget: 'Budget',
	financialOverview: 'Financial Overview',
	career: 'Career',
	lifestyleGoals: 'Goals',
	achievements: 'Achievements',
	sendMessageLabel: 'Send a message to your teacher or volunteer',
	sendMessage: 'Send Message',
	points: 'Pts',
	needs: 'Needs',
	wants: 'Wants',
	name: 'Name',
	job: 'Job',
	creditScore: 'Credit Score',
	lifeStage: 'Life Stage',
	status: 'Status',
	excellent: 'Excellent',
	great: 'Great',
	good: 'Good',
	poor: 'Poor',
	viewProfile: 'View profile',
	relationship: 'Relationship',
	interests: 'Interests',
	studentSalary: 'Net Monthly Income',
	studentSpouseNMI: 'Spouse Net Monthly Income'
};

const careerMessagesEN = {
	selectedCareerCounter: '{count}/1 selected',
	careerCountAlert: 'Select a maximum of one career.'
};

const dashboardMessagesEN = {
	messages: 'Messages',
	students: 'Students',
	resources: 'Resources',
	simulationManagement: 'Simulation Management',
	reporting: 'Reporting',
	settings: 'Settings',
	titleUnreadMsg: 'Unread Messages',
	titleAllMsg: 'All Messages',
	deleteMessageTitle: 'Are you sure that you want to delete this message?',
	na: 'N/A',
	yes: 'Yes',
	no: 'No',
	monthly: 'Monthly',
	expenses: 'expenses',
	noFacilityOption: 'No Facility',
	cms: 'CMS',
	jafp: 'JAFP',
	userManagement: 'User Management',
	evaluationQuestion: 'Evaluation Questions',
	simulationTemplates: 'Simulation Templates',
	lifeEvents: 'Life Events',
	miscUploads: 'Misc. Uploads',
	questionType: 'Question type',
	questionFormat: 'Question Format',
	enterQuestion: 'Enter question',
	answerOption: 'Answer option',
	questionOrder: 'Question order',
	others: 'Others',
	score: 'Score',
	text: 'Text',
	deleteAnswer: 'Delete answer',
	addMoreOption: 'Add more answer option',
	onlyAtEndOfSimulation: 'Only at end of Simulation',
	max: 'Max'
};

const errorPageButtonsEN = {
	errorPageBack: 'Go Back',
	errorPageToHome: 'Go to Home Page',
	reachOutToTeacher: 'Please reach out to your Teacher or Volunteer.'
};
const notFoundMessagesEN = {
	notFoundCode: '404',
	notFoundMessage: 'Page not found',
	notFoundInfo:
		'The page you are looking for might have been removed, had its name changed or is temporarily unavailable'
};
const serverErrorMessagesEN = {
	serverErrorCode: '500',
	serverErrorMessage: 'Internal Server Error',
	serverErrorInfo: 'There was an error. Please try again later.',
	serverErrorMessages: 'The following error(s) occurred:'
};

const lifeStagesEN = {
	teenager: 'Teenager',
	youngAdult: 'Young Adult',
	workingAdult: 'Working Adult',
	adultNearingRet: 'Adult Nearing Retirement',
	completedSavingsAllocations: 'Completed Savings Allocations',
	completedProfileSetup: 'Completed Profile Setup',
	child: 'child',
	adult: 'adult',
	children: 'children',
	infant: 'infant',
	infants: 'infants',
	teenagers: 'teenagers',
	numberOfStudentsBillsPaid: 'Bills paid',
	numberOfStudentsFinishedShopping: 'Finished shopping',
	numberOfStudentsWithBudgetFinalized: 'Budget finalized'
};

const lifeScenarioEN = {
	lifeStageDesc:
		'You’re all set! Here’s your life scenario. You are ready to create your budget.',
	calculateNMITitle: 'Calculate Your NMI',
	calculateNMIDesc:
		'To calculate your Net Monthly Income (NMI), subtract your taxes from your Gross Monthly Income.',
	toCalculateNMI:
		'Select each tax line to reveal the amount. After all lines are selected, the NMI will be calculated.',
	GMI: 'Gross Monthly Income',
	GAI: 'Gross Annual Income',
	yourNMIIs: 'Your Net Monthly Income is:',
	selectEachTaxLine:
		'Select each tax line to reveal the amount. After all lines are selected, the NMI will be calculated.',
	savingsTitle: 'Setup Your Savings',
	savingsDesc:
		'Setting aside money for savings is a good habit to develop. First, select how much you want to have in your general savings account. Next, you will save for the goals you selected earlier.',
	creatingBudgetTitle: 'Create your budget',
	creatingBudgetDesc:
		'A budget is a plan for your money. It’s time to create your plan. Use the sliders or enter a number in each box to allocate the amount you anticipate spending for each expense category.',
	editingBudgetTitle: 'Edit your budget',
	editingBudgetDesc:
		"It’s time to edit your budget to reflect your new life scenario. If you got married, you will have a household NMI that includes your spouse's income. Your budget allocations from the previous life stage automatically carried over. Use the sliders or enter a number in each box to adjust or allocate the amount for any anticipated changes in your spending.",
	allocateSavingsTitle: 'Allocate Your Savings',
	confirmBudgetTitle: 'Confirm Your Budget',
	confirmBudgetDescription:
		'Budgeting is important because it helps you control your spending, track your expenses, and save more money. Review your budget and confirm it when you are ready.',
	confirmBudgetBtn: 'Confirm Budget',
	allocateSavingsDescription: `Now that you know how much you bring home in a month, you can begin to think about the things you'll pay for. At the top of your list should be paying yourself!
  Saving should be a priority. It allows you to weather tough times and plan for your future.
  The shown NMI includes any deductions made for budgets and savings set in the previous life stages`,
	householdNMI: 'Household NMI',
	savingsAvailable: 'Savings Available ({percentageOfNmi}%)',
	totalAmount: 'Total goal amount',
	monthlyAmount: 'Amount to save each month',
	savingsTooltip:
		'Setting aside money for savings is a good habit to develop. First, select how much you want to have in your general savings account. Next, start saving for the goals you selected earlier.',
	sliderMinimum: 'Minimum',
	sliderLegend:
		'amount recommended for each category based on your NMI and life scenario. A warning message will display if you go above the recommended maximum amount.',
	sliderMinMsg: 'Below the recommended minimum',
	sliderMaxMsg: 'Above the recommended maximum',
	invalidBudgetOption: 'Needs Attention',
	dashboardShoppingSubtitle: 'Plan your monthly expenses',
	dashboardBudgetingSubtitle: 'Plan your budget for the month',
	dashboardBudgetingTitle: 'Allocate Your Budget'
};

const splashscreenMessagesEN = {
	splashscreenJATitle: 'Welcome to JA Finance Park!',
	splashscreenJASubtitle:
		'If you have been instructed to log in with an email address, select Email.',
	splashscreenJASubtitle2: 'Otherwise, select Account Number.',
	splashscreenGetStarted: 'Get Started',
	splashscreenAccountNumber: 'Account Number',
	splashscreenEmail: 'Email',
	splashscreenTextCookies:
		'We use cookies to provide you a personalized experience. How we do this is by analyzing user behavior on our site and sharing data with our advertising and analytics partners. You consent to our cookie policy if you continue to use this website. Please review our',
	splashscreenPrivacyPolicy: 'Privacy Policy',
	splashscreenAnd: 'and',
	splashscreenTermsAndConditions: 'Terms & Conditions',
	splashscreenTermsAndConditions2:
		'By continuing to use this site, you’re agreeing to these updates.',
	splashscreenUnderstand: 'I Understand'
};

const adminDashboardStudents = {
	dashboardStudentName: 'Name',
	dashboardStudentEmail: 'Email',
	dashboardStudentJob: 'Job/Career',
	dashboardStudentLifeStage: 'Life Stage',
	dashboardStudentCompleted: 'Completed',
	dashboardExpenseCategory: '(Expense Category)',
	dashboardAttempt: 'Attempt',
	dashboardCurrent: '(Current)',
	titleAllStudents: 'All Students',
	titleFavoriteStudents: 'Favorites',
	searchByName: 'Search by Name or Email',
	search: 'Search',
	addNewStudent: 'Add New Student',
	addNew: 'Add New',
	sortBy: 'Sort by',
	completed: 'Completed',
	noResultsFound: 'NO RESULTS FOUND!',
	favorite: 'Favorite',
	moreMenu: 'More menu button - Complete Life stage',
	completeLifeStage: 'Complete Life stage',
	forcedCompleteLifeStageStudentFromAdmin:
		'User moves to the next life stage. Are you sure?',
	selectAll: 'Select all',
	simulationName: 'Simulation Name',
	schoolName: 'School Name',
	program: 'Program',
	simulationType: 'Simulation Type',
	onSiteDate: 'On Site Date',
	simulationStartDate: 'Simulation Start Date',
	evaluationQuestions: 'Evaluation Questions',
	simulationTemplates: 'Simulation Templates',
	lifeEvents: 'Life Events',
	lifeInterest: 'Life Interest',
	lifeEventType: 'Life Event Type',
	lifeEventDescription: 'Life Event Description',
	miscUploads: 'Misc. Uploads',
	deleteMessageCms: 'Are you sure you want to delete this {title}?',
	confirmation: 'Confirmation',
	createNew: 'Create new',
	questionText: 'Question Text',
	answerType: 'Answer Type',
	onlyPost: 'Only post',
	actions: 'Actions',
	templateName: 'Template Name',
	simulationTemplate: 'Simulation Template',
	startLifeStage: 'Start Life Stage',
	endLifeStage: 'End Life Stage',
	cmsCareers: 'Careers',
	careerCluster: 'Career Cluster',
	jobTitle: 'Job Title',
	careerName: 'Career Name',
	description: 'Description',
	educationRequired: 'Education Required',
	educationDescription: 'Education Description',
	expectedDuties: 'Expected Duties',
	jobTitles: 'Job Titles',
	addNewJobTitle: 'Add New Job Title',
	lifeEventImpact: 'Live Event Impact',
	eventType: 'Event Type',
	active: 'Active',
	positive: 'Positive',
	negative: 'Negative',
	choiceOfAccount: 'Choice Of Account',
	choiceOfDoingNothing: 'Choice Of Doing Nothing',
	noChoice: 'No Choice',
	newUpload: 'New Upload',
	selectFile: 'Select File',
	logoName: 'Logo Name',
	sponsorType: 'Sponsor Type',
	chooseAnImage: 'Choose An Image',
	sponsorLogoType: 'Sponsor Logo Type',
	shoppingType: 'Shopping: Required or Optional',
	national: 'National',
	fileIsUploaded:
		'File is uploaded and will be saved once you click the "Save" button. Click the "X" to remove the File if you want to add a Link.',
	formatPNG: 'Image format should be PNG, JPG or JPEG',
	maxSize: '(Max file size is 300 KB)',
	deactivatedMessage: 'Are you sure you want to deactivate the record?',
	activatedMessage:
		'Are you sure you want to activate the record?. Active logos, with the same selected modules, will be deactivated.',
	activatedMessageLogo:
		'Are you sure you want to activate the record?. Active logos, with the same selected modules, will be deactivated.',
	deactivated: 'Deactivated',
	activated: 'Activated',
	resourcesName: 'Resources Name',
	resourcesCategory: 'Resources Category',
	expenseCategories: 'Expense Categories',
	expenseCategory: 'Expense Category',
	maxSizeLogo: 'Max logo size is 165 px width x 66 px height.',
	JAFP: 'JAFP 2.0',
	interestError: 'Interest name has to be unique',
	addResource: 'Add Resource',
	resourceName: 'Resource Name',
	resourceCategory: 'Resource Category',
	resourceDescription: 'Resource Description',
	resourceLink: 'Resource Link',
	attachment: 'Attachment',
	zipCode: 'Zip Code',
	NMICalculationRequired: 'NMI Calculation Required',
	savingsCalculationIsMandatory: 'Savings Calculation Is Mandatory',
	LifestyleGoalQuestionsForPaperBased:
		'Lifestyle Goal Questions For Paper-based',
	startOfSimulation: 'Start of Simulation',
	endOfSimulation: 'End of Simulation',
	printShoppingTemplatesDuringSimulation:
		'Print Shopping Templates During Simulation',
	roleName: 'Role Name',
	billboardLogo: 'Billboard Logo',
	chooseALogo: 'Choose a logo',
	globalRules: 'Global Rules',
	scripts: 'Scripts',
	researchPopupHeading: 'Research Popup Heading',
	researchPopupSupporting: 'Research Popup Supporting',
	researchHeader: 'Research Header',
	sponsorLogos: 'Sponsor Logos',
	researchAdditionalScripts: 'Research Additional Scripts',
	researchDidYouKnowScript: 'Research Did You Know Script',
	source: 'Source',
	addAnother: 'Add another...',
	systemName: 'System name',
	displayName: 'Display name',
	paymentOptions: 'Payment options',
	availableIn: 'Available in',
	hasQuantity: 'Has quantity',
	showMonthlyCost: 'Show monthly cost',
	costPerChildCMS: 'Cost per child',
	additionalCostCMS: 'Additional Cost',
	selectedAll: 'Selected All',
	facilityID: 'Facility ID',
	facilityName: 'Facility Name',
	address: 'Address'
};

const adminStudentsMessagesEN = {
	adminStudentsError: 'All fields are required',
	addNewMessage: 'New Message',
	addAnotherStudent: 'Add Another Student',
	delete: 'Delete',
	import: 'Import',
	importApiKey: 'Import Api Key',
	addNewStudent: 'Add New Student',
	addNew: 'Add New',
	dashboard: 'Dashboard',
	importInfo: 'Correct import format: First name, Last name, Email',
	importResultImported: '{imported} Imported!',
	importResultFailed: '{failed} Failed!',
	invalidRows: 'Invalid data at row(s): ',
	fileExtensionWarning: 'Only .csv file extension is allowed',
	freeTextLabel: 'Free Text Message',
	freeText: 'Free Text',
	predefinedTextLabel: 'Select a message',
	addMessage: 'Send New Message',
	messagePlaceholder: 'Enter your message',
	messageSentSuccessfully: 'Message sent successfully',
	messageSendingFailed: 'Message sending failed',
	topic: 'Topic',
	enterYourTopic: 'Enter your topic',
	pageResults: 'Results: {firstOnDisplay} - {lastOnDisplay} of {total}',
	firstName: 'First Name',
	lastName: 'Last Name',
	fileMaxLinesError: 'Exceeded maximum number of rows ({count})',
	viewAsStudent: 'View as a Student',
	exportStudentsEnrollment: 'Export Students Enrolment',
	markAsDone: 'Mark as Done',
	exportData: 'Export Data',
	newMessage: 'New Message',
	schoolDetails: 'School Details',
	savingDetails: 'Saving Details',
	educators: 'Educators',
	volunteers: 'Volunteers',
	messageStatus: {
		done: 'Done',
		unread: 'Unread'
	}
};

const sliderTooltipsMessagesEN = {
	minTooltip:
		'This dot indicates the minimum amount recommended for each budget based on your NMI and life scenario.',
	maxTooltip:
		'This dot indicates the maximum amount recommended for each budget based on your NMI and life scenario.'
};

const paymentMessagesEN = {
	paymentTitle: 'Payment',
	paymentSubTitle: 'Review your selections, and choose a payment method.',
	backToShoppingButton: 'Back to Shopping',
	costBreakdown: 'Cost Breakdown:',
	paymentMethodMessage: 'Choose a Payment Method:',
	totalCostMessage: 'Total Cost:',
	totalMonthlyCostMessage: 'Monthly Cost',
	payButton: 'Pay',
	skipShopping: 'I choose not to make a purchase',
	shoppingTitle: 'Shopping',
	budgetingTitle: 'Budgeting',
	shoppingSubtitle:
		"Select the items that meet your household's needs and wants.",
	required: 'Required',
	isMandatory: 'This item is required.',
	checking: 'Checking',
	availableCredit: 'Available Credit',
	notEnoughBalance: ' (Not Enough Balance)',
	onSiteSimulationShoppingSubtitle:
		'Items in this category are typically priced between ${minimum} and ${maximum} per month. Most individuals budget between {minimumPercentage}% and {maximumPercentage}% of their NMI',
	loanDescription: {
		transportation:
			'Monthly loan payment: {monthlyLoanAmount}\nAdditional expenses to cover the cost of gas and auto insurance: {additionalCost}',
		housing:
			'Monthly mortgage payment: {monthlyLoanAmount}\nAdditional expenses to cover the cost of home security and home insurance: {additionalCost}'
	},
	shoppingCostPerAdult: 'Adults ({count} @ {cost})',
	shoppingCostPerChild: 'Children ({count} @ {cost})'
};

const completeLifeStageModal = {
	greeting: 'Hey {name},',
	yourBillsAreDue:
		'Your bills are due. Did you know that paying more than your minimum payment can save you money in  interest charges?',
	itsAlmostTime:
		"It's almost time to pay your bills. You can continue shopping for now, or you can complete this life stage and continue to debt payment.",
	continueToPayment: 'Continue to Debt Payment',
	keepShopping: 'Keep Shopping',
	completeLifeStageAndContinue:
		'Complete Life Stage and Continue to Debt Payment',
	completeLifeStage: 'Complete Life Stage',
	noMoneyLeft:
		"You've completely run out of money! You can move onto the next life stage, but know that in real life poor spending decisions will negatively impact your financial situation."
};

const onboardingTutorial = {
	back: 'Back',
	next: 'Next',
	guidedTour: 'Guided Tour',
	welcomeToJAFinancePark: 'Welcome to JA Finance Park!',
	welcomeToJAFinanceParkText:
		'My name is Jimmy and I’ll be your advisor. You are almost ready to begin your financial journey and explore the many businesses in the JA Finance Park world. First, let’s go over a few tips to help you along the way.',
	calendar: 'Calendar',
	calendarText:
		'Select the calendar icon at any time to view your monthly expenses, budget, and financial health.',
	calendarTextEntry:
		'Select the calendar icon at any time to view your monthly expenses and budget.',
	research: 'Research',
	researchText:
		'Discover important information that will help you make wise shopping decisions for each expense category. Just select a business to begin researching.',
	confirmBudgetText:
		'After you’ve completed your research, take a look back at your complete budget and the funds that you allocated for each category during the research phase. You’ll be able to make adjustments before you finalize your budget.',
	shopAndBuy: 'Shop and Buy',
	shopAndBuyText:
		'Go shopping for the things you need and want. When you are finished, select a payment method to complete the purchase.',
	debtPayments: 'Debt Payments',
	debtPaymentsText:
		'Once all shopping is complete, you will have to make a credit card bill payment. (Everyone begins with some credit card debt today!) If you selected higher education, you will also have student loan debt. Be sure to have enough money to make at least the minimum monthly payment.',
	debtPaymentsTextEntry:
		'Once all shopping is complete, you will have to make a credit card bill payment. (Everyone begins with some credit card debt today!) If your persona has a degree, you will also have student loan debt. Be sure to have enough money to make at least the minimum monthly payment.',
	stayOnBudget: 'Stay on Budget',
	stayOnBudgetText:
		'Remember, the goal of a budget is to keep your finances on track and not spend more than you earn. You can always check your budget meter to track how well you are sticking to your budget.',
	stayOnBudgetNoteBolded: 'Note:',
	stayOnBudgetNoteMessage:
		'If you choose to get married, your spouse’s NMI will automatically be added into your new budget total. But keep in mind, you must budget for your entire family!',
	stayOnBudgetNoteMessageEntry:
		'If you have a spouse, their NMI will automatically be added into your new budget total. Keep in mind, you must budget for your entire family!',
	financialHealth: 'Financial Health',
	financialHealthText:
		'All the decisions you make from savings to spending, and even how quickly you pay off debt, affect your financial health score. Look for the emoji to know where you stand.',
	goodLuck: 'Good Luck!',
	goodLuckText:
		'You are now ready to begin your JA Finance Park journey. Let’s go!',
	howIsThisCalculated: 'How is this calculated?',
	titlePayingDownDebt: 'Paying Down Debt Quicker',
	textPayingDownDebt:
		'Paying off more than your minimum payment saves you money on interest in the long run.',
	titleAccumulatingGeneralSavings: 'Accumulating General Savings',
	textAccumulatingGeneralSavings:
		'Saving money each month means you don’t have to take out as much debt and can save money on interest payments.',
	titleWorkingTowardsGoals: 'Working Towards Goals',
	textWorkingTowardsGoals:
		'Work towards your future goals by saving each month. See how much progress you can make each life stage.',
	titleStickingYourBudget: 'Sticking to Your Budget',
	textStickingYourBudget:
		'Making purchases that do not exceed the amount you budgeted for each expense category.',
	titleMonitoringYourCreditScore: 'Monitoring Your Credit Score',
	textMonitoringYourCreditScore:
		'Based on your credit history, this number indicates how well you manage your credit and can affect your ability to take out loans and credit cards in the future.'
};

const researchMessagesEN = {
	backToHome: 'Back to Home',
	didYouKnow: 'Did you know',
	discardPurchasesMessage: 'Are you sure you want to discard all purchases?',
	discardAllPurchases: 'Discard All Purchases'
};

const budgetingMessagesEN = {
	minRecommended: 'Minimum Recommended',
	maxRecommended: 'Maximum Recommended',
	setBudget: 'Set Budget',
	allBudgets: 'All Budgets',
	yourBudget: 'Your Budget',
	budgeted: 'Budgeted',
	NMI: 'NMI',
	leftToBudget: 'Left to Budget',
	ofYourBudget: 'of your budget',
	budgetLeft: 'Left to Spend',
	financialHealth: 'Financial Health',
	backToResearch: 'Back to Research',
	amountSpent: 'Amount Spent',
	leftToSpent: 'Amount Left To Spend',
	creditCardPurchases: 'Credit Card Purchases',
	amountPaid: 'Amount Paid',
	amountLeftToPay: 'Amount Left to Pay',
	savings: 'Savings',
	generalSavings: 'General Savings',
	debt: 'Debt',
	debts: 'Debts',
	creditCard: 'Credit Card',
	totalLoans: 'Total Loans',
	postSecondaryLoans: 'Post-Secondary Education Loan',
	creditCardLoans: 'Credit Card Loans',
	postLoans: 'Post-Secondary Loans',
	savingsAccountBalance: 'Savings Account(s) Balance:',
	netMonthlyIncome: 'Net Monthly Income:',
	outstandingDebt: 'Outstanding Debt:'
};
const lifeStageSummaryEN = {
	lifeStageSummary: 'Life Stage Summary',
	lifeStageSummaryMsg: 'You have finished your {lifeStageName} years!',
	total: 'Total',
	totalSpent: 'Total Spent',
	totalUnused: 'Total Unused',
	congratulations: 'Congratulations!',
	congratulationsMsg: 'You successfully completed the simulation.',
	generalSavings: 'General Savings',
	lifeStageSummaryBtn: 'Continue to {lifeStageName} stage',
	oneMonthSpending: "Summary of One Month's Spending",
	projectedSpending: 'Projected Financials Over Time',
	oneMonthSpendingWithoutCreditCard:
		'Here’s how much you spent from your checking account for one month.',
	oneMonthSpendingSubtitle:
		'Here’s how much you spent from your checking account and charged to your credit card for one month.',
	projectedSpendingWithoutStudentLoan:
		'Across the entire span of {years} years in this life stage, assuming that you saved or paid the same amount each month, your savings account balance is displayed below.',
	projectedSpendingSubtitle:
		'Across the entire span of {years} years in this life stage, assuming that you saved or paid the same amount each month, your savings account balances and remaining balance of postsecondary loans are displayed below.',
	yourFinancialHealth: 'Your financial health is',
	postsecondaryLoan: 'Post Secondary Loan',
	postSecondaryLoanDebt: 'Post Secondary Loan debt',
	paid: 'Paid'
};
const educationEN = {
	educationTitle: 'Postsecondary Education',
	educationMsg:
		'Time to make some big choices! Select what you plan to do after high school, keeping in mind what your selected career path may require. Note you will likely incur some postsecondary education loan debt based on your choice, that you will repay over time.',
	educationError:
		'Your selection does not align with the recommended level for your career path. Select a different education level, or go back and select a different career.',
	militaryMsg:
		'Serving in the military is a noble choice! Keep in mind, the career you selected requires postsecondary education. During or after your service, you will need to earn a degree or certification to begin work.'
};

const savingsInfoMessagesEN = {
	totalAmountToSave: 'Total Amount to Save',
	annualInterestRate: 'Annual Interest Rate',
	amountToSavePerMonth: 'AMOUNT TO SAVE PER MONTH',
	timeToAchieveGoal: 'Time it will take to achieve this goal:',
	monthSingular: 'month',
	monthPlural: 'months'
};

const hopesAndDreamsEN = {
	yourFutureTitle: 'Your Future',
	finish: 'Finish',
	subtitleYourFuture:
		"As you begin the next life stage, you can decide whether or not you'll get married, have children, and have pets by selecting one or more of the images below. If you decide not to at this time, select Finish without checking any of the boxes. You can always decide to in the next life stage.",
	select: 'Select'
};

const studentsLoanPaymentEN = {
	studentLoanPaymentTitle: 'Your student loan payment is due',
	makePayment: 'Make Payment',
	totalLoanAmountToPay: 'Total Amount to Pay: ',
	tuition: 'Tuition',
	interest: 'Interest',
	minimumPaymentDue: 'Minimum payment due',
	monthlyPaymentAmount: 'Monthly Payment Amount',
	paymentMethod: 'Payment Method',
	checkingAccount: 'Checking Account',
	savingsAccount: 'Savings Account',
	savings: 'Savings',
	errorMessageLowerAmount: 'You must pay at least the minimum amount due.',
	errorMessageTransportation:
		"Now that you're married, please choose at least two transportation methods.",
	errorMessageIsMandatory:
		'To complete your purchase, you must make a shopping selection.',
	noticeForNotEnoughMoneyInChechingAccount:
		'Uh-oh! You do not have enough money to make the minimum payment. Paying your student loan late means you´ll face higher interest charges, a late fee, and a negative mark on your credit score, making future loans more expensive and harder to get. It´s crucial to manage your payments on time to avoid these costly consequences.',
	studentLoanAmountLeftToPay: 'Amount Left to Pay'
};

const creditCardPaymentEN = {
	creditCardPaymentModal: 'Your credit card payment is due',
	balance: 'Balance',
	startingBalance: 'Starting balance',
	purchases: 'Purchases',
	interest: 'Interest',
	amountToPay: 'Amount to Pay',
	noticeCreditForNotEnoughMoneyInChechingAccount:
		'Uh-oh! You do not have enough money to make the minimum payment. Paying your credit card late means you´ll face higher interest charges, a late fee, and a negative mark on your credit score, making future loans more expensive and harder to get. It´s crucial to manage your payments on time to avoid these costly consequences.'
};

const lifeEventMessagesEN = {
	thatsLife: 'That is Life',
	availableBalance: 'Available Balance',
	checkingAccount: 'Checking Account',
	payWithChecking: 'Pay with Checking',
	payWithCredit: 'Pay with Credit',
	payWithSavings: 'Pay with Savings',
	hey: 'Hey',
	checkingAccountEvents: 'Checking Account',
	creditAccountEvents: 'Credit Account',
	savingsAccountEvents: 'Savings Account',
	payWith: 'Pay with',
	addTo: 'Add to'
};

const calendarEN = {
	accountBalance: 'Account Balance',
	totalInvested: 'Total Invested',
	balance: 'Balance',
	creditLimit: 'Credit Limit',
	remainingBalance: 'Remaining Balance',
	currentBalance: 'Current Balance',
	originalLoanAmount: 'Original Loan Amount',
	outstandingBalance: 'Outstanding Balance',
	savingsTitle: 'Savings',
	principal: 'Principal',
	additionlCost: 'Other Costs',
	savingsSubtitle: 'Saved this month',
	debtTitle: 'Debt',
	debtSubtitle: 'Minimum scheduled to pay off',
	expensesTitle: 'Expenses',
	expensesSubtitle: 'Spent this month',
	sponsoredBy: 'Sponsored by',
	poweredBy: 'Powered by',
	debtTooltip:
		'At the end of this month, you will be notified when it is time to pay your {typeOfDebt} bills. Remember to have some money set aside!',
	loanTooltip:
		'You already paid your loan for the month! Please note that some of the payment will go towards the principal and some will go towards interest. Always try to send in at least the minimum payment each month to pay your loan off in time!',
	unavailableDashboardCategory: 'This category is currently not available.'
};

const worldMessagesEN = {
	zoomHelp: 'Select the magnifying glass to zoom in and zoom out of the map.',
	dragHelp: 'Select and drag anywhere to move around the map.',
	calendarОnboardingTitle: 'Plan Your Month',
	calendarОnboarding:
		'Select the Calendar to see the activities and expenses you have planned for this month.',
	calendarОnboardingGeneral:
		'Welcome to your calendar of monthly expenses. Let’s take a quick tour.',
	calendarОnboardingSavings:
		'Track the progress of your savings goals. See how the balance grows over the course of your life.',
	calendarОnboardingExpCat:
		'Track how much you have spent in each expense category. Make sure not to go over budget!',
	calendarОnboardingConclusion:
		'When you are ready to visit the many businesses in JA Finance Park, tap or select the Close button at the bottom of the screen to return back home.',
	pauseModalSubtitle:
		'The simulation has been paused. Please wait for further instruction.',
	dashboardOnboardingIntro: `Welcome to your home screen. Let's take a quick tour. `,
	dashboardOnboardingProfile: `You can view your Financial Health and access your profile information at any time.`
};

const simManagementEN = {
	templateLbl: 'Template Name',
	facilityLbl: 'Facility',
	simulationLbl: 'Simulation Name',
	bcrmLbl: 'BCRM Class Number',
	programLbl: 'Program Name',
	simulationPinLbl: 'Simulation PIN (AI Teacher Dashboard)',
	simStartDateLbl: 'Simulation Start Date',
	simEndDateLbl: 'Simulation End Date',
	simStartHourLbl: 'Simulation Start Date Time',
	simEndHourLbl: 'Simulation End Date Time',
	visitStartDateLbl: 'Visit Start Date',
	visitEndDateLbl: 'Visit End Date',
	visitStartHourLbl: 'Visit Start Time (Hrs)',
	visitStartMinuteLbl: '(Min)',
	visitEndHourLbl: 'Visit End Time (Hrs)',
	visitEndMinuteLbl: '(Min)',
	schoolLbl: 'School Name',
	percentageOfNmiToSavings: 'Percentage of NMI to Savings',
	lunchLbl: 'Free/Reduced Lunch Percentage',
	educatorNameLbl: "Educator's Name",
	educatorEmailLbl: "Educator's Email Address",
	volunteerNameLbl: "Volunteer's Name",
	volunteerEmailLbl: "Volunteer's Email Address",
	lastLogin: 'Last Login',
	email: 'Email',
	newSimulation: 'New Simulation',
	facility: 'Facility',
	sortBy: 'Sort by',
	filterBy: 'Filter by',
	schoolName: 'School Name',
	program: 'Program',
	applyFilters: 'Apply Filters',
	clearFilters: 'Clear Filters',
	sessionName: 'Simulation Name',
	school: 'School name',
	programName: 'Program Name',
	visitStartDate: 'Visit Start Date',
	simulationPin: 'Simulation PIN',
	simStartDate: 'Sim Start Date',
	deleteSimulationTitle: 'Are you sure you want to delete this simulation?',
	addStudents: 'Add Students',
	confirmStudentsSelection: 'Confirm your selection',
	add: 'Add',
	simulationTypeLbl: 'Simulation Type',
	all: 'All',
	simType: 'Sim type',
	studentDeleteConfirmation:
		'Are you sure? All current data for the student in this simulation will be lost once he/she is removed.',
	studentAddSimRemovalConfirmation:
		'Are you sure? The enrolled student will be removed from this class and from all reports.',
	studentAddSimRemovalListConfirmation:
		'Are you sure? You will take the student out of the enrollment for this class.',
	financePark: 'Finance Park',
	ums: 'UMS',
	noResults: 'No results',
	participationCount:
		'Participant in {count} simulation | Participant in {count} simulations',
	usersHasSimulationsMessage:
		'Some of the selected students are related to existing simulations!',
	wholeArea: 'Whole Area',
	importData: 'Import Data',
	sync: 'Sync',
	export: 'Export',
	exportDataWarning:
		'Please do not export during an active simulation. Are you sure there are no active simulations?',
	importFile: 'Import File',
	importDataWarning:
		'Please do not import during an active simulation. Are you sure there are no active simulations?',
	download: 'Download',
	copy: 'Copy'
};

const studentAtGlanceReport = {
	studentProgressTitle: 'Student At-a-Glance Report',
	totalStudents: 'Total Students: {n}',
	selectedFilters: 'Selected Filters',
	avatarSelectionProgressLbl: 'Avatar Selection',
	preQuestionsProgressLbl: 'Pre-Sim Questions',
	interestsProgressLbl: 'Interests',
	goalsProgressLbl: 'Savings goals',
	careerProgressLbl: 'Career',
	educationProgressLbl: 'Education',
	completedCategoriesLbl: 'Expense Categories Completed',
	completedCategoriesLabel: '{0} / {1} Expense Categories Completed',
	priceOutOfAll: '{0} / {1}',
	facilityFilter: 'Facility',
	simTypeFilter: 'Simulation Type',
	schoolFilter: 'School Name',
	educatorFilter: 'Educator Name',
	classFilter: 'Class Name',
	lifeStageFilter: 'Life Stage',
	showDetails: 'Show Details',
	hideDetails: 'Hide Details',
	attemptCounter: 'Attempt: {n}',
	showAll: 'Show All',
	attemptsForSim: 'Attempts for {name}'
};

const reportingEN = {
	reportType: 'Report Type',
	studentAtGlance: 'Student At-a-Glance',
	simulationEvaluation: 'Simulation Evaluation',
	studentSummary: 'Student Simulation Summary',
	simulationSnapshot: 'Simulation Snapshot',
	filters: 'Filters',
	facilityPlaceholder: 'Select Facility',
	autoLoanBankingAndFinance: 'Auto Loan Banking and Finance',
	mortgageLoan: 'Mortgage Loan',
	autoLoanDealership: 'Auto Loan Dealership',
	educationLoan: 'Education Loan',
	chooseReportTypeTxt: 'Choose a report type above to start',
	schoolNameLbl: 'School Name:',
	schoolNamePlaceholder: 'Type in first three letters of School Name',
	educatorName: 'Educator Name',
	educatorNamePlaceholder: 'Type in first three letters of Educator Name',
	className: 'Class Name',
	classNamePlaceholder: 'Select Class Name',
	lifestagePlaceholder: 'Select Life Stage',
	studentName: 'Student Name',
	studentNamePlaceholder: 'Type in first three letters of Student Name',
	startDate: 'Start Date',
	selectStartDate: 'Select Start Date',
	allFacilities: 'All facilities',
	generateReport: 'Generate Report',
	downloadReport: 'Download Report',
	studentReportTitle: 'Student Simulation Summary Report',
	studentNameLbl: 'Student Name:',
	studentEmailLbl: 'Student Email:',
	simDateLbl: 'Simulation Date:',
	jobTitleLbl: 'Job:',
	educationLbl: 'Education:',
	lifeStageLbl: 'Life stage:',
	teacherNameLbl: 'Educator Name:',
	creditScoreLbl: 'Credit Score:',
	careerEducationLbl: 'Career and Education',
	goalsLbl: 'Goals:',
	childrenLbl: 'Children:',
	futureAndGoals: 'Future and Goals',
	nmiLbl: 'NMI:',
	householdNMILbl: 'Household NMI:',
	familyLbl: 'Family:',
	interestsLbl: 'Interests:',
	budgetingSection: 'Budgeting / Spending Summary',
	financeOverviewSection: 'Financial Overview',
	print: 'Print',
	savingsChartLbl: 'Savings / {savingName}',
	general: 'General',
	studentLoan: 'Student Loan',
	LoanApprovals: 'Loan Approvals',
	pet: 'pet',
	pets: 'pets',
	expenseCategories: 'Expense Categories',
	reportTableSubheader: 'Actual/Budgeted',
	fullyPayed: 'Paid in Full',
	availableAutoLoan: 'Available Auto Loan Banking and Finance',
	availableAutoLoanDealership: 'Available Auto Loan Dealership',
	availableMortgageLoan: 'Available Mortgage Loan',
	approvedToSpend: 'Approved to spend up to',
	purchaseWith: 'Purchase with'
};

const simulationSnapshotEN = {
	totalStudentsInSimulation:
		'Total of Students Participating in the Simulation: {studentsCount}',
	percentageOfStudentsCompleted: '{studentsPercentage}% of Students Completed ',
	ofStudentsCompleted: '{studentsPercentage}% Completed',
	ofStudentsNotCompleted: '{studentsPercentage}% Not completed',
	totalOfStudentsCompleted:
		'Total of Students Completed the Simulation: {studentsCount}'
};

const specialSymbols = {
	currency: 'USD',
	currencySymbol: '$',
	enDash: '–' //https://www.accessc.com/articles/hyphen-en-dash-em-dash.html
};

const accessibilityEN = {
	selectStudentsToDownload: 'Select students to download',
	exploreCareerMsg: 'Explore {careerCluster}',
	goToCluster: 'Go to {careerCluster} career cluster',
	goNextCluster: 'Go to the next career cluster',
	goPrevCluster: 'Go to the previous career cluster',
	avatarSelected: 'Avatar selected',
	goHomePage: 'Navigate to home page',
	openOnboarding: 'Open guided tour screen',
	toggleDropdownMenu: 'Toggle dropdown menu',
	goToQuestionnaire: 'Navigate to questionnaire page',
	goToClustersPage: 'Navigate to career clusters page',
	goToNextQuestion: 'Go to the next question',
	submitAnswers: 'Submit your answers',
	pageLoading: 'The page is loading',
	answerSelected: 'Answer {answer} selected',
	answerUnselected: 'Answer {answer} unselected',
	interestSelected: '{interest} selected',
	interestUnelected: '{interest} unselected',
	selectCareer: 'Select {career}',
	showMoreCareer: 'Show more about {career}',
	showLessCareer: 'Show less about {career}',
	backToClusters: 'Go back to career clusters page',
	goEducationPage: 'Navigate to select your education page',
	goGoalsPage: 'Navigate to select your goals page',
	error: 'error',
	warning: 'warning',
	loaded: 'has loaded',
	opened: 'has opened',
	closed: 'has closed',
	careerSelected: '{career} selected',
	careerUnselected: '{career} unselected',
	careerPageEntered: 'Select your career page',
	clustersPageEntered: 'Select career cluster page',
	avatarPageEntered: 'Select your avatar page',
	pretestPageEntered: 'Pretest questionnaire page',
	goalsPageEntered: 'Select your goals page',
	interestsPageEntered: 'Select your interests page',
	educationPageEntered: 'Select your education page',
	congratulationsPageEntered: 'Congratulations page',
	studentSummaryEntered: 'Student summary report page',
	homePageEntered: 'Home page',
	categoryPageEntered: 'Category page',
	loginPageEntered: 'Login page',
	calendarPageEntered: 'Calendar page',
	profilePageEntered: 'Profile page',
	selectEducation: 'Select {education}',
	educationSelected: '{education} selected',
	goalSelected: '{goal} selected',
	goalUnselected: '{goal} unselected',
	goToSimulation: 'Navigate to home page',
	categoryModalName: '{category} expense category screen',
	lifeStageIntroModalName: 'Life stage intro screen',
	completeLifeStageModalName: 'Complete life stage screen',
	studentLoanModalName: 'Student loan payment screen',
	creditCardModalName: 'Credit card payment screen',
	lifeStageSummaryModalName: 'Life stage summary screen',
	hopesDreamsModalName: 'Choose your future screen',
	lifeEventModalName: 'Life event screen',
	sendMessageModalName: 'Send message screen',
	logoutModalName: 'Logout screen',
	pauseModalName: 'Simulation paused screen',
	guidedTourModalName: 'Guided tour screen',
	goNMISection: 'Go to calculate your net monthly income section',
	goBudgetSection: 'Go to edit your budget section',
	taxSelected: '{tax} selected',
	taxUnselected: '{tax} unselected',
	taxAmount: 'Your {tax} amount is ${amount}',
	yourNMI:
		'Your net monthly income has been calculated. Your net monthly income is ${amount}',
	expandBudget: 'Expand {category} budget section.',
	collapseBudget: 'Collapse {category}',
	budgetSection:
		'Section {category}. Your current budget for {category} is ${amount}.',
	amountSpentCategory: 'Amount to spent each month for {category}.',
	amountSaveCategory: 'Amount to save each month for {category}.',
	totalGoalAmount: 'Set the total goal amount for {category} goal.',
	budgetSet: 'Budget for {name} is set to ${amount}.',
	budgetLeftToSpent: 'Your budget left to spent is ${amount}.',
	setRecommendedMinBudget:
		'Set the budget for {name} to the recommended minimum, which is ${amount}.',
	budgetUnsufficient:
		'The budget set exceeds your remaining household net monthly income. Please edit your budget.',
	budgetMinWarning: 'Warning! The budget set is below the recommended minimum.',
	budgetMaxWarning: 'Warning! The budget set is above the recommended maximum.',
	editBudgetLoaded: 'Edit your budget section has loaded.',
	calculateNmiLoaded: 'Calculate your net monthly income section has loaded.',
	saveYourBudgets: 'Save your monthly budget and go to the simulation.',
	totalSavingsAmountSet:
		'Your total savings amount for {name} goal are set to ${amount}',
	tutorialStarted:
		'Junior achievement finance park onboarding tutorial has started',
	goCalendar: 'Navigate to the calendar page.',
	calendarOnboardingStarted: 'Calendar page onboarding tutorial has started.',
	goNextOnboardingStep: 'Go to next onboarding tutorial step.',
	finishCalendarTutorial: 'Finish calendar onboarding tutorial.',
	finishOnboarding: 'Finish the onboarding tutorial.',
	categoryList: 'List with expense categories',
	toggleSidebar: 'Toggle sidebar',
	expanded: 'expanded',
	currentBudget: 'Your current budget left to spend is: ${budget}.',
	currentFinancialHealth: 'Your current financial health is: {status}.',
	navigateToProfile: 'Click to navigate to profile page.',
	profileStatus:
		'Your current profile status is: {marriedStatus}; {childrenStatus}; {petStatus}. Click to navigate to profile page.',
	closeModal: 'Close dialog window',
	navigateCategory: 'Navigate to {category} page',
	selectShoppingItem: 'Select {item} for ${value}',
	costPerChild:
		'Cost per child is ${cost}. The total cost for {count} children is ${total}.',
	costPerAdult:
		'Cost per adult is ${cost}. The total cost for {count} adults is ${total}.',
	shoppingCardSelected: '{subcategory} selected.',
	shoppingCardUnselected: '{subcategory} unselected.',
	paymentType: '{type} with balance: ${balance}',
	requiredCategory: 'This category is required.',
	quantity: 'quantity',
	payWithMethod: 'Pay ${amount} with {method}',
	paymentLoading: 'Payment loading',
	paymentCompleted: 'Payment Completed',
	finishShopping: 'Finish shopping for {category} and navigate to home page',
	categoryCompleted: '{category} is completed!',
	NMIChart:
		'A pie chart showing how much you spent from your checking account with balance ${NMI} for one month.',
	creditAccountChart:
		'A pie chart showing how much you spent from your credit card account with card limit ${limit} for one month.',
	amountSpentChart: 'Amount spent is ${amountSpent}.',
	amountLeftChart: 'Amount left to spend is ${amountLeft}.',
	totalSavingsChart:
		'A pie chart showing how much you would save in this life stage, your total savings are ${totalSavings}.',
	monthlySavingsChart:
		'A pie chart showing how much you would save for one month, your total savings are ${totalSavings}.',
	totalDebtChart:
		'A pie chart showing how much you would save in this life stage, your total savings are ${amount}.',
	monthlyDebtChart:
		'A pie chart showing how much debt is scheduled to pay off for one month, your total debt is ${amount}.',
	postLoanProjectedChart:
		'A pie chart showing how much post secondary education loan debt you would pay in this life stage, your total post secondary education loan debt is ${amount}.',
	paidDebtChart: 'Your paid debt is ${amount}',
	dueDebtChart: 'Your debt left to pay is ${amount}',
	creditCardChart: 'Your credit card debt is ${amount}.',
	postLoanChart: 'Your Post-Secondary education loan debt is ${amount}.',
	loanTotal:
		'Your Post-Secondary education loan debt is <strong>${amount}</strong>.',
	outstandingAmount:
		'Your Outstanding Amount for Post-Secondary Loans is <strong>${amount}</strong>.',
	minimumPayment:
		'Your minimum Payment for Post-Secondary Loans is <strong>${amount}</strong>.',
	savingChart: 'Your amount saved for {goal} is ${goalAmount}.',
	expandInfo:
		'How is this calculated? Expand information about financial health.',
	collapseInfo: 'Collapse information about financial health.',
	yourFutureUnselected: '{item} unselected',
	yourFutureSelected: '{item} selected',
	moreInfoSavings: 'More information about savings',
	married: 'married',
	notMarried: 'notMarried',
	categoryBudgetSummary:
		'{category}; total expenses: ${expenses}; budget set: ${budget}',
	closeProfile: 'Close profile page and navigate back to home page',
	guidedTourOnboardinTutorial:
		'Junior Achievement Finance Park guided tour tutorial has started',
	goNextGuidedTourStep: 'Go to the next guided tour step',
	goBackGuidedTourStep: 'Go to the previous guided tour step',
	closeGuidedTourStep: 'Close guided tour',
	closeCalendar: 'Close calendar page and navigate back to home page',
	savingDashboardItem:
		'{name}; saved this month: ${amount}; account balance: ${balance}',
	creditCardDashboardItem:
		'{name}; Minimum scheduled to pay of: ${amount}; remaining balance: ${balance}; credit limit: ${limit}',
	postLoanDashboardItem:
		'{name}; Minimum scheduled to pay of: ${amount}; remaining balance: ${balance}/${totalBalance}',
	moreInfoCreditCard: 'More information about credit card debt',
	moreInfoPostLoan: 'More information about Post Secondary Loan debt',
	completeButtonAppeared:
		'You can now complete the life stage. To complete the life stage, select the Complete Life Stage button.',
	sessionWillexpireText:
		'Your session is about to expire. If your session expires, all of the data which is not submitted will be lost',
	sessionWillexpirePressOkText: 'Press “OK” to proceed the session.',
	sessionWillExpireModalName: 'Session will expire screen',
	sessionLostText: 'Another session was open for the same user.',
	sessionLostModalName: 'Session was lost',
	proceed: 'Proceed',
	relogin: 'Relogin',
	welcomeBack: 'Welcome back',
	welcomeBackText: 'This account {account} is already in use.',
	welcomeBackTextHeader: 'Your current simulation is: ',
	lastSimulationId: 'Simulation ID: ',
	studentId: 'Troubleshooting ID: ',
	welcomeBackSinceNow: 'just now',
	welcomeBackSinceMinutes: 'minute ago | minutes ago',
	welcomeBackSinceHours: 'hour ago | hours ago',
	welcomeBackSinceDays: 'day ago | days ago',
	financialHealthStatus: 'Financial health: {status}',
	downloadReport: 'Download report',
	continueFinalPage: 'Navigate to congratulations page',
	finalFinanceChart:
		'A pie chart showing how much you spent and saved in this simulation.',
	finalDebtChart:
		'A pie chart showing how much debt you paid and how much debt is left to be paid in this simulation.',
	checkingAccountAmount: 'Your checking account has ${amount}',
	savingsAccountAmount: 'Your {goal} savings are ${amount}',
	LoanApprovalsAmount: 'Your Loan Approvals are ${amount}',
	finalDebtAmount: 'Your paid debt for {debt} is ${debtAmount}.',
	backToReport: 'Navigate back to student summary report page.',
	finishSimulation: 'Finish your simulation and log out from the application.',
	noChildren: 'No children',
	noPets: 'No pets',
	totalCostSelection:
		'Total cost of your selections is ${cost}. Your budget set for this category is ${budget}',
	calculateNMIAriaTitle: 'Calculate your net monthly income.',
	toCalculateNMIAbbr:
		'Select each tax line to reveal the amount. After all lines are selected, the net monthly income will be calculated.',
	householdNMIAbbr: 'Household net monthly income: ${amount}',
	savingsAvailableAbbr: 'Savings available: ${amount}',
	alreadyAppliedForLoan:
		'You have successfully applied for a loan. You will be notified when your application has been processed.',
	haveToApplyForLoanInfo:
		'You should submit an application for {loan} loan in order to be able to proceed to the next stage. | You should submit applications for auto and mortgage loans in order to be able to proceed to the next stage.',
	loanApplicationStatus: 'Loan Application Status',
	loanStatusMessages: {
		congrats:
			// TODO: Fix this to work with both loans separately
			'Congratulations! You have been approved for an <strong>auto loan!</strong> | Congratulations! You have been approved for a <strong>mortgage loan!</strong> | Congratulations! You have been approved for an auto loan and a mortgage loan!',
		autoLoan: `Congratulations! You have been approved for an <strong>auto loan dealership!</strong> and the amount you have been approved for is <strong>{autoLoanAmount}</strong>. Now you can choose a car and purchase it from the Transportation category.`,
		bothAutoLoan: `Congratulations! You have been approved for an <strong>auto loan banking and finance!</strong> and the amount you have been approved for is <strong>{autoLoanAmount}</strong> and an <strong>auto loan dealership!</strong> and the amount you have been approved for is <strong>{autoLoanDealershipAmount}</strong>. Now you can choose a car and purchase it from the Transportation category.`,
		autoLoanBankingAndFinance: `Congratulations! You have been approved for an <strong>auto loan banking and finance!</strong> and the amount you have been approved for is <strong>{autoLoanAmount}</strong>. Now you can choose a car and purchase it from the Transportation category.`,
		mortgageLoan: `Congratulations! You have been approved for a <strong>mortgage loan!</strong> and the amount you have been approved for is <strong>{mortgageLoanAmount}</strong>. Now you can choose a house and purchase it from the Housing category.`,
		disclaimerAuto:
			'Unfortunately, you haven’t been approved for a <strong>auto loan</strong> but you can still  buy a ticket from the transportation category.',
		disclaimer:
			'Unfortunately, you haven’t been approved for a <strong>mortgage loan</strong> but you can still rent a house from the Housing category.',
		bothLoansBanking: `Congratulations! You have been approved for an auto loan banking and finance and a mortgage loan! You have been approved for the loan amount <strong>{autoLoanAmount}</strong> for a car and <strong>{mortgageLoanAmount}</strong> for a house.`,
		bothLoans: `Congratulations! You have been approved for an auto loan dealership and a mortgage loan! You have been approved for the loan amount <strong>{autoLoanDealershipAmount}</strong> for a car and <strong>{mortgageLoanAmount}</strong> for a house.`,
		allLoans: `Congratulations! You have been approved for an auto loan banking and finance, auto loan dealership and a mortgage loan! You have been approved for the auto loan banking and finance amount <strong>{autoLoanAmount}</strong> and auto loan dealership amount <strong>{autoLoanDealershipAmount}</strong> for a car and <strong>{mortgageLoanAmount}</strong> for a house.`
	},
	applyForLoanNote: {
		required:
			'Please note, that you must submit your {loanType} application before you complete your budgeting.',
		optional: 'You can apply for an {loanType} at any time while budgeting.'
	},
	autoLoan: 'Auto loan',
	autoLoans: 'Auto loans',
	mortgageLoan: 'Mortgage loan',
	studentInformation: 'Student Information',
	simTypePlaceholder: 'Select Simulation Type',
	autoLoanPlaceholder: 'Select Auto Loan'
};

const installerModal = {
	downloadInstaller: 'Download Installer',
	noFacility: 'The user does not belong to any facility!'
};

const syncModal = {
	syncHeading: 'CMS Sync'
};

export const metaTitles = {
	adminMetaTitles: {
		messages: 'Messages',
		students: 'Students',
		resources: 'Resources',
		reporting: 'Reporting',
		simManagement: 'Simulation Management',
		settings: 'Settings',
		CMS: 'CMS',
		JAFP: 'JAFP 2.0',
		facility: 'Facility',
		userManagement: 'User Manage...',
		evaluationQuestions: 'Evaluation Questions',
		simulationTemplates: 'Simulation Templates',
		careers: 'Careers',
		interest: 'Interest',
		expenseCategories: 'Expense Categories',
		lifeEvents: 'Life Events',
		miscUploads: 'Misc. Uploads'
	},
	gamePlayMetaTitles: {
		avatar: 'Avatar',
		pretest: 'Pre test',
		interests: 'Interests',
		goals: 'Goals',
		clusters: 'Career Clusters',
		careers: 'Careers',
		education: 'Education',
		calendar: 'Calendar',
		category: 'Category',
		profile: 'Profile',
		chooseSim: 'Choose Simulation',
		changeReport: 'Reports',
		congrats: 'Congratulations',
		posttest: 'Post test',
		knowledge: 'Knowledge',
		questionnaire: 'Questionnaire'
	},
	generalMetaTitles: {
		loginVirtual: 'Login Virtual',
		loginOnSite: 'Login OnSite',
		default: 'Finance Park | Junior Achievement'
	}
};

export const adminSettings = {
	simulationPasscodeLocations: {
		afterAllocateSavingsPasscode: 'Allocate Savings',
		afterLifeScenarioPasscode: 'Life Scenario',
		afterLifeStageSummaryPasscode: 'Life Stage Sumary',
		afterSetBudgetPasscode: 'Set Budget',
		afterCalculateNMIPasscode: 'Assign Your Savings',
		afterLifeStageIntroPasscode: 'Calculate NMI'
	},
	tables: {
		location: 'Stage',
		passcode: 'Passcode',
		category: 'Category',
		variable: 'Variable',
		value: 'Value',
		area: 'Area',
		variables: {
			autoLoanCoefficient: 'Auto Loan Coefficient',
			autoLoanCreditScoreThreshold: 'Auto Loan Credit Score Threshold',
			mortgageLoanCreditScoreThreshold: 'Mortgage Loan Credit Score Threshold',
			mortgageLoanHighSaverCoefficient: 'Mortgage Loan High Saver Coefficient',
			mortgageLoanLowSaverCoefficient: 'Mortgage Loan Low Saver Coefficient',
			autoLoanInterest: 'Auto Loan Interest Rate',
			mortgageLoanInterest: 'Mortgage Loan Interest Rate',
			autoLoanDealershipInterest: 'Auto Loan - Dealership Interest Rate',
			autoLoanDealershipCoefficient: 'Auto Loan - Dealership Coefficient',
			autoLoanDealershipCreditScoreThreshold:
				'Auto Loan - Dealership Credit Score Threshold'
		}
	},
	simPasscodesTitle: 'Simulation Passcodes',
	categoriesPasscodesTitle: 'Expense Categories Passcodes',
	passcodes: 'Passcodes',
	variables: 'Variables'
};

export const chatbot = {
	chatbotLabel: 'Ask for help',
	chatbotPlaceholder: 'Enter your message...',
	chatbotPlaceholderDisabled: 'You’re banned. Contact your teacher for help.',
	chatbotTitle: 'Chatbot',
	chatbotErrorMessage:
		'Sorry, there was an error processing your message. Please try again.',
	chatbotPlaceholderExceeded:
		'Question limit reached. Please ask your teacher for help.',
	chatBotSend: 'Send',
	introMessageLabel:
		'Hi, I’m Jimmy 👋\nThink of me like your super-smart sidekick here to help you make awesome money choices during your JA Finance Park adventure! 💸🏙️\n\nJust a quick heads-up:\nI’m here to help you learn, so let’s keep things kind and appropriate.\nYour teachers and the JA Staff can see what you ask me, so make sure it’s all cool! ✅\n\nReady to roll?\nLet’s jump in and see how I can help you today!\nWhat do you want to learn about money? 💬💰',
	firstStrike: `Let’s keep it classy. Please refrain from using inappropriate language and asking questions that don’t pertain to your experience in JA Finance Park.`,
	secondStrike: `We’re getting off track. Please be aware that your teachers will have access to all the questions asked. Remember, this AI is here to assist with your JA Finance Park experience. Please focus your questions on the simulation.`,
	thirdStrike: `Well, that escalated quickly. Due to the nature of the questions you have asked, the AI feature will no longer be available to you for the duration of your time in JA Finance Park. Please ask your teacher for further assistance. Good luck with the rest of your simulation!`,
	instantBan: `instantBan Well, that escalated quickly. Due to the nature of the questions you have asked, the AI feature will no longer be available to you for the duration of your time in JA Finance Park. Please ask your teacher for further assistance. Good luck with the rest of your simulation!`,
	unknow: `I don't know - let's keep it JA Finance Park specific`,
	notify: `ALERT: This message will be notified to the teacher and/or volunteers.`,
	notifyMessage: `It has been detected that the student {studentName} {studentLastName} used inappropriate language in the following query:\n"{queryContent}".\n Please review the incident and take the appropriate actions.\nSincerely,\nFinance Bot`,
	queryWarningMessage: `‼️ Hey {studentName} - you only have 5 questions remaining. Make them worth it ‼️`,
	requestsExceededMessage: `Believe it or not - you've reached your chatbot limit. Now use everything you've learned and apply it to the rest of your JA Finance Park experience`,
	strikeLabel:
		'‼️ Uh oh! That’s a strike for saying something inappropriate or off-topic. Three strikes = no access, and your teacher will be notified. ‼️',
	defaultQuestions: {
		1: `What does NMI stand for?`,
		2: `What are the different educational levels?`,
		3: `What is a credit score?`
	},
	defaultAnswers: {
		1: `Net Monthly Income is the amount of money you take home each month after taxes and other deductions are taken out of your paycheck. It’s the money you can actually spend or save. For example, if you earn $2,000 a month but $500 is taken out for taxes and other deductions, your net monthly income would be $1,500.`,
		2: `Sure! Here’s a quick overview of educational levels:\n\n1. **Trade/Vocational School**: These programs focus on specific skills for a particular job, like plumbing or cosmetology. They usually take less time to complete and can lead to certifications.\n\n2. **Associate's Degree**: Typically a 2-year degree offered by community colleges. It can prepare you for a specific career or be a stepping stone to a Bachelor's degree.\n\n3. **Bachelor's Degree**: A 4-year degree from a college or university. It provides a broader education and is often required for many professional jobs.\n\n4. **Master's Degree**: This is a graduate degree that usually takes 1-2 years after earning a Bachelor's. It allows for specialization in a specific field, like business or education.\n\n5. **Doctorate**: The highest level of education, which can take several years to complete. It involves advanced study and research, leading to a Ph.D. or other doctoral degrees.\n\nEach level opens up different career opportunities, so it's important to think about what you want to do in the future!`,
		3: `A credit score is a number that shows how likely you are to pay back borrowed money. It usually ranges from 300 to 850, with higher scores indicating better creditworthiness. Lenders use it to decide if they will give you a loan or credit card and what interest rate to offer you. Good credit scores can help you get better deals on loans and lower interest rates.`
	}
};

export const messagesEN = {
	...accessibilityEN,
	...reportingEN,
	...studentAtGlanceReport,
	...worldMessagesEN,
	...errorPageButtonsEN,
	...notFoundMessagesEN,
	...serverErrorMessagesEN,
	...globalMessageEN,
	...interestsMessagesEN,
	...goalsMessagesEN,
	...careerClustersMessagesEN,
	...avatarsMessagesEN,
	...profileMessagesEN,
	...careerMessagesEN,
	...dashboardMessagesEN,
	...lifeScenarioEN,
	...lifeStagesEN,
	...adminStudentsMessagesEN,
	...lifeStageSummaryEN,
	...logoutEN,
	...loginMessagesEN,
	...splashscreenMessagesEN,
	...onboardingTutorial,
	...adminDashboardStudents,
	...sliderTooltipsMessagesEN,
	...paymentMessagesEN,
	...budgetingMessagesEN,
	...researchMessagesEN,
	...educationEN,
	...savingsInfoMessagesEN,
	...hopesAndDreamsEN,
	...studentsLoanPaymentEN,
	...lifeEventMessagesEN,
	...calendarEN,
	...simManagementEN,
	...creditCardPaymentEN,
	...completeLifeStageModal,
	...reportingEN,
	...simulationSnapshotEN,
	...specialSymbols,
	...installerModal,
	...metaTitles,
	...adminSettings,
	...syncModal,
	...chatbot
};
